import { useEffect, useState } from 'react'

import { SuccessModal } from 'components'
import LoadingComponent from 'components/LoadingComponent/LoadingComponent'
import { ILoading } from 'hooks/useStatePage'
import useToggle from 'hooks/useToggle'
import { createContext } from 'use-context-selector'
import { SucessModalType } from 'components/SuccessModal/SuccessModal'
import { hasTokenRefreshError } from 'services/Instances/utils'
import zIndex from '@mui/material/styles/zIndex'

interface ILoadingContext {
  loading: string
  loadingMessage?: string
  setLoadingMessage?: (message: string) => void
  setLoading: (newValue: ILoading) => void
  msgErro: string
  setMsgErro: (newValue: string, titleModal?: string) => void
  setMsgSucesso: (
    newValue: string,
    titleModal?: string,
    type?: SucessModalType
  ) => void
  toggleSucessShow: () => void
}
export const LoadingContext = createContext<ILoadingContext | null>(null)

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState<ILoading>('idle')
  const [loadingMessage, setLoadingMessage] = useState<string>('')
  const [msgErro, changeMsgErro] = useState<string | undefined>()
  const [modalTitle, setModalTitle] = useState<string | undefined>()
  const [typeSucessoMessage, setTypeSucessoMessage] = useState<
    SucessModalType | undefined
  >('sucess')
  const [msgSucesso, changeMsgSucesso] = useState<string | undefined>()

  const [sucessShow, toggleSucessShow] = useToggle()
  const [alertShow, toggleAlertShow] = useToggle()

  const setMsgErro = (newValue: string, titleModal?: string) => {
    typeof newValue == 'string'
      ? changeMsgErro(newValue)
      : changeMsgErro('Ocorreu um erro inesperado')
    if (titleModal != undefined) {
      setModalTitle(titleModal)
    } else setModalTitle('Erro')
  }

  const setMsgSucesso = (
    newValue: string,
    titleModal?: string,
    type?: SucessModalType
  ) => {
    changeMsgSucesso(newValue)

    if (type) {
      setTypeSucessoMessage(type)
    } else {
      setTypeSucessoMessage('sucess')
    }

    if (titleModal != undefined) {
      setModalTitle(titleModal)
    } else setModalTitle('Sucesso')
  }

  return (
    <LoadingContext.Provider
      value={{
        loading,
        msgErro,
        setLoading,
        setMsgErro,
        setMsgSucesso,
        toggleSucessShow,
        setLoadingMessage
      }}
    >
      {/*  PAGE */}
      {children}
      {/* LOADING */}
      {loading === 'loading' ? (
        <LoadingComponent message={loadingMessage} />
      ) : null}
      {/* HANDLE ERRO */}
      {loading === 'error' && !hasTokenRefreshError() && (
        <SuccessModal
          open={loading === 'error'}
          type="error"
          titleModal={modalTitle}
          message={msgErro}
          hideButtonCancel
          txtButtonConfirm="Fechar"
          handleConfirm={() => setLoading('idle')}
        />
      )}
      {loading === 'error' && hasTokenRefreshError() && (
        <SuccessModal
          open={loading === 'error'}
          type="alert"
          titleModal={'Alerta'}
          message={hasTokenRefreshError()}
          hideButtonCancel
          txtButtonConfirm="Fechar"
          handleConfirm={() => {
            setLoading('idle')
            window.localStorage.clear()
            //window.location.reload();
          }}
        />
      )}
      {!!sucessShow && (
        <SuccessModal
          open={sucessShow}
          type="sucess"
          titleModal={modalTitle}
          message={msgSucesso}
          hideButtonCancel
          txtButtonConfirm="Fechar"
          handleConfirm={toggleSucessShow}
        />
      )}
      {!!sucessShow && (
        <SuccessModal
          open={sucessShow}
          type={typeSucessoMessage}
          titleModal={modalTitle}
          message={msgSucesso}
          hideButtonCancel
          txtButtonConfirm="Fechar"
          handleConfirm={toggleSucessShow}
        />
      )}
    </LoadingContext.Provider>
  )
}
